import React, { FC, useState } from 'react';
import ModalComponent from 'ReusableComponents/Modal/ModalComponent';
import { ButtonComponent } from 'ReusableComponents/Button/ButtonComponent';
import { removeShifts, updateShiftStatus } from '../shiftApi';
import { ShiftStatusType } from 'const/ShiftConst';
import { RadioComponent } from 'ReusableComponents/Radio/RadioComponent';
import { handleError } from '../utils';

const ShiftChangeModal: FC<{
  shiftId: string;
  courierName: string;
  showModal: boolean;
  setShowModal: (open: boolean) => void;
  onlyDelete?: boolean;
}> = ({ shiftId, courierName, showModal, setShowModal, onlyDelete }) => {
  // TODO fix below, a fetch maybe?
  const shiftCount = 4;
  const [checkedValue, setCheckedValue] = useState<
    | ShiftStatusType.CANCELED
    | ShiftStatusType.DECLINED
    | ShiftStatusType.DISPATCH_DECLINED
    | ShiftStatusType.DELETED
  >(onlyDelete ? ShiftStatusType.DELETED : null);

  const handleRemoveShift = () => {
    checkedValue === ShiftStatusType.DELETED
      ? removeShifts([shiftId]).catch(handleError)
      : updateShiftStatus(shiftId, checkedValue).catch(handleError);
    setShowModal(false);
  };
  return (
    <ModalComponent
      className="shiftChangeModal"
      open={showModal}
      setOpen={setShowModal}
    >
      <h1>Shift change</h1>
      <div>
        <p>{courierName}</p>
        <p>{shiftCount} shifts this week</p>
      </div>
      {!onlyDelete && <h2>Choose one:</h2>}
      <div className="shiftChangeModal__radio">
        {!onlyDelete && (
          <>
            <RadioComponent
              id="shiftChangeModal-1"
              name="shiftChangeModal-radio"
              label={{
                node: `Courier did not respond, so marking declined by dispatcher *`,
              }}
              checked={checkedValue === ShiftStatusType.DISPATCH_DECLINED}
              value={ShiftStatusType.DISPATCH_DECLINED}
              onChange={() =>
                setCheckedValue(ShiftStatusType.DISPATCH_DECLINED)
              }
            />
            <RadioComponent
              id="shiftChangeModal-2"
              name="shiftChangeModal-radio"
              label={{ node: `${courierName} has declined this shift` }}
              checked={checkedValue === ShiftStatusType.DECLINED}
              value={ShiftStatusType.DECLINED}
              onChange={() => setCheckedValue(ShiftStatusType.DECLINED)}
            />
            <RadioComponent
              id="shiftChangeModal-3"
              name="shiftChangeModal-radio"
              label={{ node: 'We overbooked this courier' }}
              checked={checkedValue === ShiftStatusType.CANCELED}
              value={ShiftStatusType.CANCELED}
              onChange={() => setCheckedValue(ShiftStatusType.CANCELED)}
            />
          </>
        )}
        <RadioComponent
          id="shiftChangeModal-4"
          name="shiftChangeModal-radio"
          label={{ node: 'Remove shift' }}
          checked={checkedValue === ShiftStatusType.DELETED}
          value={ShiftStatusType.DELETED}
          onChange={() => setCheckedValue(ShiftStatusType.DELETED)}
        />
      </div>
      <p
        style={{
          margin: '15px 5px 0 5px',
          fontSize: '12px',
        }}
      >
        * Shift declined by dispatcher does not count to loyalty bonus
      </p>
      <div className="shiftChangeModal__buttons">
        <ButtonComponent
          disabled={!checkedValue}
          text="Confirm"
          customColor={{ background: '#443df6', color: 'white' }}
          onClick={handleRemoveShift}
        />
        <ButtonComponent
          text="Cancel"
          variant="outlined"
          onClick={() => setShowModal(false)}
        />
      </div>
    </ModalComponent>
  );
};

export default ShiftChangeModal;
